/**
 * External dependencies.
 */
import React, { useState, useEffect, createRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { animateScroll } from 'react-scroll';

/**
 * Internal dependencies.
 */
import LoadMore from './../load-more';
import ArticleList from './article-list';
import PRESS_ARTICLES from './queries/press-articles';

/**
 * PressArticles Component.
 *
 * @param {Object} props Component props.
 *
 * @return {jsx}
 */
const PressArticles = ( { initialPosts } ) => {
	const perPage = 12;
	const [ items, setItems ] = useState( initialPosts );
	const [ lastItemsCount, setLastItemsCount ] = useState( 0 );
	const isFirstSet = ( items.length <= perPage );
	const canShowLoadMore = ( ! isEmpty( items ) && items.length > ( perPage - 1 ) );
	const ref = createRef();
	const refIndex = lastItemsCount ? ( items.length - lastItemsCount ) : 0;

	/**
	 * Scroll to the first article from the last loaded batch
	 * when load-more button was clicked.
	 */
	const scrollToArticle = () => {
		if ( lastItemsCount && ref.current ) {
			animateScroll.scrollTo( ref.current.offsetTop - 10 );
		}
	}

	useEffect( () => scrollToArticle(), [ items ] ); /* eslint-disable-line */

	return (
		<>
			<ArticleList
				posts={ items }
				animate={ ! isFirstSet }
				ref={ ref }
				refIndex={ refIndex }
			/>
			{ canShowLoadMore ? (
				<LoadMore
					items={ items }
					setItems={ setItems }
					setLastItemsCount={ setLastItemsCount }
					perPage={ perPage }
					QUERY={ PRESS_ARTICLES }
					postKey="pressArticles"
				/>
			) : null }
		</>
	);
};

PressArticles.propTypes = {
	initialPosts: PropTypes.array,
};

PressArticles.defaultProps = {
	initialPosts: [],
}

export default PressArticles;
